import * as React from 'react';
import {Chip} from "@material-ui/core"

import FaceIcon from '@material-ui/icons/Face';
import {Tab} from "../Tab";



export interface TabsNavigationItemProps {
	tab: Tab,
	title: string,
	isActive: boolean
	handleDelete: (tab: Tab) => void
	handleSelect: (tab: Tab) => void
}

export interface TabsNavigationItemState {
}

class TabsNavigationItem extends React.Component<TabsNavigationItemProps, TabsNavigationItemState> {

	constructor(props: TabsNavigationItemProps) {
		super(props)
	}

	componentDidMount() {
	}

	render(): React.ReactNode {

		let variant: any
		variant = this.props.isActive ? 'default' : 'outlined'

		return (
			<div className='ev-tab-navigation-item'>
				<Chip
					icon={<FaceIcon />}
					label={this.props.title}
					clickable = {true}
					onClick = {this.handleClick.bind(this)}
					className={'ev-tab-navigation-item-chip'}
					color="primary"
					onDelete={this.handleDelete.bind(this)}
					variant={variant}
				/>
			</div>
		);
	}

	private handleDelete () {
		this.props.handleDelete(this.props.tab)
	}

	private handleClick () {
		this.props.handleSelect(this.props.tab)
	}
}

export default TabsNavigationItem
